<template>
  <div class="earthquake-report-view">
    <EarthquakeReportComponent />
  </div>
</template>

<script>
import EarthquakeReportComponent from '../components/report/earthquakeReportComponent.vue';

export default {
  components: {
    EarthquakeReportComponent,
  },
  data() {
    return {

    };
  },
  methods: {

  },
};
</script>